import React, { useState, useEffect } from 'react';
//import left_img from '../images/left_side_caladine.png';
//import right_img from '../images/right_side_caladine.png';
import { Link } from 'react-router-dom';
import axios from 'axios';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

let loadPage = true;

export const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            //text: 'Chart.js Bar Chart',
        },
    },
};

const labels = ['Surat Edaran', 'Rekomendasi Kajian', 'Peraturan Gubernur', 'Peraturan Daerah', 'Naskah Akademik', 'Keputusan Gubernur', 'Katalog Produk Hukum','Instruksi Gubernur'];

export const data = {
    labels,
    datasets: [
        {
            label: 'Kategori Produk Hukum',
            data: [0,0,0,993,349,0,0,19],
            backgroundColor: 'rgba(169, 239, 122, 0.5)',
        },
    ],
};

function GrafikData() {
   
    useEffect(() => {
        if (loadPage) {
            //Chart();
        }
        return () => {
            loadPage = false
        };
    }, []);

    return (
        <div class="max-w-full mx-auto bg-white">
            <Bar options={options} data={data} />
        </div>
    );
}

export default GrafikData;
